export const MIN_GOAL = 1;
export const MAX_GOAL = 20;
